import { useEffect, CSSProperties, useState } from "react";

const getCssProperties = (footer: any) => {
    const styles = {};

    if (footer?.topBackgroundColor) {
        styles["--footer-top-background-color"] = footer.topBackgroundColor;
    }
    if (footer?.topTextColor) {
        styles["--footer-top-text-color"] = footer.topTextColor;
    }
    if (footer?.topHeadingColor) {
        styles["--footer-top-heading-color"] = footer.topHeadingColor;
    }
    if (footer?.bottomBackgroundColor) {
        styles["--footer-bottom-background-color"] = footer.bottomBackgroundColor;
    }
    if (footer?.bottomTextColor) {
        styles["--footer-bottom-text-color"] = footer.bottomTextColor;
    }

    // Social Links

    if (footer?.socialLinkColor) {
        styles["--footer-icon-fill-color"] = footer.socialLinkColor;
    }
    if (footer?.hoverSocialLinkColor) {
        styles["--footer-icon-hover-fill-color"] = footer.hoverSocialLinkColor;
    }

    // Anchor

    if (footer?.topAnchorColor) {
        styles["--footer-top-anchor-text-color"] = footer.topAnchorColor;
    }
    if (footer?.topHoverAnchorColor) {
        styles["--footer-top-anchor-hover-text-color"] = footer.topHoverAnchorColor;
    }

    if (footer?.bottomAnchorColor) {
        styles["--footer-bottom-anchor-text-color"] = footer.bottomAnchorColor;
    }
    if (footer?.bottomHoverAnchorColor) {
        styles["--footer-bottom-anchor-hover-text-color"] = footer.bottomHoverAnchorColor;
    }

    return styles;
};

export default (footer?: any): any => {
    const [result, setResult] = useState<CSSProperties>(getCssProperties(footer));

    useEffect(() => {
        setResult(getCssProperties(footer));
    }, [footer]);

    return result;
};